<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap>
                <v-flex xs9>
                  <div>
                    <h3>Select Bank</h3>
                    <v-select
                      class="mx-300"
                      :items="banks"
                      item-text="name"
                      item-value="id"
                      label="Select a bank"
                      v-model="selected_bank"
                      prepend-icon="account_balance"
                      solo
                    ></v-select>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-card-text class="pt-0 my-3">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <div>
                    <h3>Start Date</h3>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="start_menu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="start_date"
                        label="Select Start Date"
                        prepend-icon="event"
                        readonly
                        solo
                      ></v-text-field>
                      <v-date-picker v-model="start_date" @input="start_menu = false"></v-date-picker>
                    </v-menu>
                  </div>
                </v-flex>

                <v-flex xs12 sm6>
                  <div>
                    <h3>End Date</h3>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="end_menu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="end_date"
                        label="Select End Date"
                        prepend-icon="event"
                        readonly
                        solo
                      ></v-text-field>
                      <v-date-picker v-model="end_date" @input="end_menu = false"></v-date-picker>
                    </v-menu>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-flex justify-center pb-3>
                <v-btn color="primary" @click="generateReport">Generate Report</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "../../../layouts/admin"
import { mapState } from "vuex"
import { GENERATE_BANK_REPORT } from "@/store/actions/ptspAdmin"
export default {
  name: "AdminMarshals",
  data() {
    return {
      page_title: "Generate Bank Report",
      getDate: new Date(),
      selected_bank: "",
      start_date: new Date().toISOString().substr(0, 10),
      start_menu: false,
      end_date: new Date().toISOString().substr(0, 10),
      end_menu: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    }
  },
  computed: {
    ...mapState({
      banks: state => state.common.banks
    }),
    percent_done() {
      return ((this.merchant.done / this.merchant.expected) * 100).toFixed(2)
    }
  },
  methods: {
    toroute(route) {
      this.$router.push(route)
    },
    generateReport() {
      const query = {
        from: this.start_date,
        to: this.end_date,
        bankId: this.selected_bank
      }
      this.$store.dispatch(GENERATE_BANK_REPORT, query).then(() => {
        // Show form submitted toast
      })
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  }
}
</script>

<style scoped>
.full-width {
  width: 100%
}
.mx-300 {
  max-width: 300px
}
.box {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block
}
</style>

